/**
 * A tag as it's stored: lowercase letters, digits and hyphens, with spaces written as hyphens, up
 * to `maxCharacters`. Null when nothing usable is left.
 */
export function normalizeTag(value: string, maxCharacters: number): string | null {
  const tag = value
    .normalize("NFKD")
    .toLowerCase()
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[\s_]+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, maxCharacters)
    .replace(/-$/, "");
  return tag || null;
}

/** A tag as people read it: `holy-roman-empire` reads "Holy Roman Empire". */
export function tagLabel(tag: string): string {
  return tag
    .split("-")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
